export enum RequestExcusableShippingType {
  Serviceable = 0,
  Unserviceable = 1,
}
